const About = () => {
    return(
        <div className="homeAboutCon">
            <h2 className="homeAboutHeader">Hvem er vi? <span></span></h2>
        </div>
    )
}

export default About;